import { useTranslation } from "@refinedev/core";
import { Calendar } from "components/customIcons";
import { IEventDetail } from "interfaces";
import moment from "moment";

export const TicketOnSale = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  const { translate } = useTranslation();
  
  return (
    <div className="box-container">
      <div className="w-full flex flex-row items-start gap-x-2">
        <div className="w-40 shrink-0 flex flex-row items-center gap-x-2">
          <Calendar />
          {translate("eventSetup.eventInfo.ticketSalePeriod.registrationDate")}:
        </div>
        <p>
          {eventDetailData?.open_registration_date
            ? moment(eventDetailData?.open_registration_date).format(
                "HH:mm DD/MM/YYYY"
              )
            : ""}{" "}
          -{" "}
          {eventDetailData?.close_registration_date
            ? moment(eventDetailData?.close_registration_date).format(
                "HH:mm DD/MM/YYYY"
              )
            : ""}
        </p>
      </div>
    </div>
  );
};
